/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { BaseIcon } from '../../internal/BaseIcon';
export var ArrowDUturnLeftDownIcon32Regular = forwardRef('ArrowDUturnLeftDownIcon32Regular', function (props, ref) {
    return (React.createElement(BaseIcon, __assign({ ref: ref, viewBoxSize: 32 }, props),
        React.createElement("path", { d: "M8 14.5C8 8.701 12.701 4 18.5 4S29 8.701 29 14.5V22a1 1 0 1 1-2 0v-7.5a8.5 8.5 0 0 0-17 0v9.971l5.77-6.155a1 1 0 1 1 1.46 1.368l-6.041 6.444a3 3 0 0 1-4.378 0l-6.04-6.444a1 1 0 1 1 1.459-1.368L8 24.471V14.5Z" })));
});
